module.exports = __webpack_public_path__ + "img/image47.99ca1c2a.jpg";